import { ActivatedRoute } from '@angular/router';
import { WHITE_SPACE } from './constants';
import _ from 'lodash';

export class Utilities {
  public static Copy(subject: any): any {
    return JSON.parse(JSON.stringify(subject));
  }

  public static formatThousands(value: any): string {
    if (value) {
      const unformattedValue = value.toString().replace(WHITE_SPACE, ''),
        decimalValue = parseFloat(unformattedValue.replace(',', '.'));
      return decimalValue.toLocaleString('ru-RU');
    }
    return value;
  }

  public static copyUnexistedProperties(target: any, source: any) {
    Object.keys(target).forEach((targetKey) => {
      if (
        target[targetKey] === null &&
        source !== null &&
        typeof source !== 'undefined' &&
        source[targetKey] !== null &&
        typeof source[targetKey] === 'object'
      ) {
        target[targetKey] = source[targetKey];
      } else if (
        target[targetKey] !== null &&
        typeof target[targetKey] === 'object' &&
        source !== null &&
        typeof source !== 'undefined'
      ) {
        Utilities.copyUnexistedProperties(target[targetKey], source[targetKey]);
      }
    });
  }

  public static getLastRoute(route: ActivatedRoute) {
    return () => {
      let child = route.firstChild;
      while (child.firstChild) {
        child = child.firstChild;
      }
      return child;
    };
  }

  public static isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
    return typeof obj === 'undefined' || obj === null;
  }

  public static isNull<T>(obj: T | null): obj is null {
    return obj === null;
  }

  public static isUndefined<T>(obj: T | undefined): obj is undefined {
    return obj === undefined;
  }

  public static convertToNumber(value: string | number | null): number | null {
    if (typeof value === 'string') {
      return _.toNumber(value.replace(',', '.'));
    }
    return value;
  }

  public static isIe(): boolean {
    return (
      navigator.appName === 'Microsoft Internet Explorer' ||
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      navigator.appVersion.indexOf('Trident/') > -1
    );
  }
}
